<template>
    <div>
        <ResourceDialog
            :visible="visible"
            :is-no-padding="true"
            title="推送到其他网站"
            :width="props.dialogWidth"
            @on-close="handleCancel"
            appendToBody
        >
            <div
                v-loading="loading"
                style="min-height: 220px; padding-bottom: 30px"
            >
                <template v-for="item in brandList" :key="item.dtBrand">
                    <div class="website-item-check-cont">
                        <div>
                            <el-checkbox
                                v-model="item.select"
                                @change="
                                    val => {
                                        selectChange(item, val);
                                    }
                                "
                            >
                                <span class="website-name">{{
                                    item.siteName
                                }}</span>
                            </el-checkbox>
                        </div>
                    </div>
                    <div v-show="item.select" style="padding: 0 20px 0 20px">
                        <el-radio-group v-model="item.openScop">
                            <el-radio label="community_open" size="large"
                                >公开</el-radio
                            >
                            <el-radio label="personal" size="large"
                                >个人私有</el-radio
                            >
                        </el-radio-group>
                        <PublishDialogVue
                            ref="pushFormList"
                            :id="props.id"
                            :tenant="item.dtTenant"
                            :brand="item.dtBrand"
                            :scope="item.openScop"
                            :isOverflow="props.isOverflow"
                            :visible="item.select"
                            :showConfirmButton="false"
                        ></PublishDialogVue>
                    </div>
                </template>
                <template v-if="brandList.length === 0">
                    <div class="empty-container">
                        <div class="empty-wrapper">
                            <img
                                src="@/assets/img/resource/my-resource-empty.png"
                                alt=""
                            />
                            <div class="empty-not-search">
                                <p>暂无可推送的站点</p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="btn-con">
                <el-button
                    class="srt-el-button srt-el-button--cancel srt-el-button-h36"
                    @click="handleCancel"
                    >取消
                </el-button>
                <el-button
                    type="primary"
                    class="srt-el-button srt-el-button--primary srt-el-button-h36"
                    @click="handleConfirm"
                    :disabled="brandList.length === 0"
                    :loading="loading"
                    >确定</el-button
                >
            </div>
        </ResourceDialog>
    </div>
</template>
<script setup lang="ts">
import ResourceDialog from '../resource-dialog.vue';
import {ref, watch} from 'vue';
import PublishDialogVue from './PublishDialog.vue';
import Message from '@/components/message/message.js';
type IPushAssetsSiteList = {
    dtBrand: string; // 品牌;
    dtTenant: string; // 空间;
    pushed: boolean; // 是否已推送;
    siteName: string;
}[];
type IBrandList = {
    siteName: string;
    dtBrand: string; // 品牌;
    dtTenant: string; // 空间;
    pushed: boolean; // 是否已推送;
    select: boolean;
    openScop: 'community_open' | 'personal';
}[];

type IPostData = {
    id: string;
    pushInfoList: {
        communityOpenInfo: {
            chooseCategoryOptionList: [
                {
                    categoryCode: string;
                    optionCode: string;
                    optionName: string;
                }
            ];
            // delayOpenTimeDuration: 0;
            // delayOpenTimeUnit: string;
            visibleTime: number;
        };
        dtBrand: string;
        dtTenant: string;
        openScop: 'community_open' | 'personal';
    }[];
};
const props = withDefaults(
    defineProps<{
        id?: string;
        visible: boolean;
        dialogWidth?: number;
        isOverflow?: boolean;
        showConfirmButton?: boolean;
    }>(),
    {
        id: undefined,
        dialogWidth: 750,
        visible: false,
        isOverflow: true,
        showConfirmButton: true
    }
);
const emit = defineEmits(['update:visible', 'success']);

const pushFormList = ref([]);
const loading = ref(false);
const brandList = ref<IBrandList>([]);

watch(
    () => props.visible,
    async val => {
        if (val) {
            getBrandList();
        }
    }
);

// 获取可推送的站点列表
const getBrandList = async () => {
    loading.value = true;
    try {
        const res: {data: IPushAssetsSiteList} = await G_transmit(
            'getPushAssetSiteList',
            {queries: {id: props.id}}
        );
        const list = res.data.map(item => {
            return {
                ...item,
                select: false,
                openScop: 'community_open' as const
            };
        });
        brandList.value = list;
    } catch (error) {
        console.error(error);
    }
    loading.value = false;
};

// 推送确认
const handleConfirm = async () => {
    loading.value = true;
    if (brandList.value.filter(item => item.select).length === 0) {
        Message({type: 'info', text: '请先选择要推送的网站'});
        loading.value = false;
        return;
    }
    try {
        const validList: any[] = [];
        brandList.value.forEach((item, index) => {
            if (item.select) {
                validList.push(
                    // @ts-ignore
                    pushFormList.value[index].getParams()
                );
            }
        });
        const communityOpenInfoList = await Promise.all(validList);
        const siteInfoList: IPostData['pushInfoList'] = [];
        brandList.value
            .filter(item => item.select)
            .forEach((item, index) => {
                siteInfoList.push({
                    dtBrand: item.dtBrand,
                    dtTenant: item.dtTenant,
                    openScop: item.openScop,
                    communityOpenInfo: communityOpenInfoList[index]
                });
            });
        const params: IPostData = {
            id: props.id,
            pushInfoList: siteInfoList
        };
        const res = await G_transmit('pushResourceToOtherSite', {data: params});
        Message({type: 'success', text: '推送成功'});
        handleCancel();
        emit('success');
    } catch (error: any) {
        console.log('error', error);
        Message({
            type: 'info',
            text: error.message || error.status?.desc || '请将必填项填写完整'
        });
    }
    loading.value = false;
};

//
const handleCancel = () => {
    brandList.value = [];
    emit('update:visible', false);
};

//选中取消时重置是否私有
const selectChange = (item, value) => {
    if (!value) item.openScop = 'community_open';
};
</script>
<style lang="scss" scoped>
.btn-con {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    .el-button + .el-button {
        margin-left: 20px;
    }
    .el-button {
        width: 76px;
    }
}
.empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 30px;
    .empty-wrapper {
        width: 260px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .empty-not-search {
        width: 240px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
    img {
        display: block;
        width: 240px;
        height: 160px;
    }
    p {
        line-height: 26px;
        color: var(--color-gray);
        font-size: 14px;
        margin-bottom: 15px;
    }
    .create-btn {
        width: 86px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
    }
}
.website-item-check-cont {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
}
.website-name {
    color: #222222;
    font-size: 16px;
    font-weight: bold;
    max-width: 688px;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>
